import CONSTANTS, { COMPONENT_TYPES } from "../src/constants"

export const dataUrl = "/content/kohler-india/in/en.model.json"
export const contactUsUrl = "/support/contact.model.json"
export const findAStoreUrl = "/locations/find-a-store.model.json"
export const diwaliSaleUrl = "/p/promotions/diwali-sale.model.json"
export const blogUrl = "/blog.model.json"
export const downloadFileURL = "/crm/asset/download"
export const productEnquiryUrl = "/place-an-enquiry.model.json"
// temporary url for lower env, will change after authoring
export const transactEStoreUrl = "test-pages/test-ravneet.model.json"
export const dealerEnquiryURL = "/dealership-enquiry.model.json"
export const storeLandingURL =
  "/locations/find-a-store/kohler-experience-centres.model.json"
export const returnsUrl = "/returns.model.json"
export const orderDetailsPageDataUrl = "/orders/order-details.model.json"
export const orderConfirmationDataUrl = "/orders/order-confirmation.model.json"
export const orderHistoryPageDataUrl = "/orders/order-history.model.json"
export const orderStatusPageDataUrl = "/orders/order-status.model.json"
export const REGISTER_OFFLINE_PRODUCTS_DATA_URL = `/my-account/product-registration/register-offline-product.model.json`
export const REGISTER_ONLINE_PRODUCTS_DATA_URL = `/my-account/product-registration/register-online-product.model.json`
export const pressroomUrl = "/press-room.model.json"
export const returnConfirmationUrl = "/return-confirmation.model.json"
export const returnRequestUrl = "/return-request.model.json"
export const dealerEnquiryCitiesURL =
  "/etc/acs-commons/lists/Kohler/in/en/dealership/cities/jcr:content.list.json"
export const headerUrl =
  "/content/experience-fragments/kohler-india/india/en/navigation/header/header_qa_testing/global-header-experience-fragment/master"
export const footerUrl =
  "/content/experience-fragments/kohler-india/india/en/navigation/footer/Global-footer-experience-fragment/master1"
export const kohlerCareUrl = "/p/kohler-care"
export const cartItemsEndPoint = "/cart/items"
export const addFavoritesEndPoint = id => {
  return `/shopping-list/add/${id}?type=product`
}
export const favoritesEndPoint =
  "/shopping-list/Favorites?lang=" + process.env.NEXT_PUBLIC_LOCALE
export const addressEndPoint = "/cart/address"
export const GLOBAL_CONFIGURATION_PATH =
  "/bin/kohler/services/globalconfig.kohler-india.json"
export const emailSubscribeEndPoint = "/clevertap/newsletter/subscription"
export const FIND_MY_ORDERS_ENDPOINT = "/checkout/orders/v1/query"
export const FIND_MY_ORDERS_ENDPOINT2 = "/checkout/orders/query"
export const DEFAULT_CARD_DETAILS_API_PATH =
  "/bin/kohler/services/list?path=/content/kohler-india"
export const PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/pdp/product"
export const PRODUCT_DATA_URL = `/p/product-detail-page.model.json`
export const PHONE_REGEX = /^[6-9]{1}[0-9]{9}$/
export const cartDataUrl = "/cart.model.json"
export const cartPage = "/cart"
export const HOMEPAGEURL = "/content/kohler-india/in/en.html"
export const checkoutDataUrl = "/checkout.model.json"
export const panConsentEndPoint = id =>
  `/cart/items?cartId=${id}&expand=calculation`
export const orderSubmitEndPoint = "/checkout/order/submit"
export const PAYMENT_URL = "/payment/ccavenue/iframe"
export const DECRYPT_PAYMENT_RESP = "/payment/ccavenue/decrypt"
export const PAY_BY_LINK_URL = "/ccavenue/paybylink?channel=india"
export const RZ_PAY_BY_LINK_URL = "/payment/paybylink"
export const RZPAY_ORDER_CREATION = "/payment/order"
export const RZPAY_PAYMENT_VERIFY = "/payment/verify"
export const checkDuplicacyUrl = "/customer/signup?stage=initial"
export const checkDuplicacyUrlForUpdateNumber = "/customer/users"
export const resetFactorUrl = "/customer/factor/reset"
export const enrollFactorUrl = "/customer/factor/enroll"
export const updateNumberUrl = "customer/profile"
export const sendTriggerURL = "clevertap/events"
export const GET_ORDER_ENDPOINT = orderId => `/checkout/${orderId}`
export const PLP_END_POINT_CLIENT = "/search/plp"
export const apimAemURL = "/aem/resource?resourcepath="
export const ORDER_INVOICE_URL = (invoiceNo, orderNo) =>
  `/checkout/order/invoice?filename=invoice_${invoiceNo}.pdf&orderNumber=${orderNo}`
export const CREDIT_NOTE_URL = (creditNo, orderNo) =>
  `/checkout/order/invoice?filename=creditNote_${creditNo}.pdf&orderNumber=${orderNo}`
export const brandTransactSwitcher =
  process.env.NEXT_PUBLIC_BRAND_TRANSACT_SWITCHER
export const resourceFacetLabels = (persona = "GST") => [
  "masterSKU_s",
  "sourceId_s",
  "preferenceSku_s",
  "SKUColorSwatchFilename_ss",
  "ProductDescriptionProductShort_s",
  "ProductBrandName_s",
  "metaTitle_s",
  "productName_s",
  "id",
  "productImages.url_ss",
  "slug_s",
  "Product_Category",
  "displayPriceStartingAt_s",
  `priceList.${persona}.price_d`,
  `priceList.${persona}.finalPrice_d`,
  `priceList.${persona}.discountedPrice_d`,
  `priceList.${persona}.saleOffer_s`,
  `priceStartingAt.${persona}_d`,
  `discountedPriceStartingAt.${persona}_d`,
  "variantList.sku_ss",
  "SKUColorFinishName_ss",
  "Color.SKU.Details_ss",
  `Color.${persona}.Details_ss`,
  "ProductExclusive_s",
  "RegionReleaseforShipment_dt",
  "productImages.labelWithUrl_ss",
  "productImageVariantImages.labelWithUrl_ss",
  "ProductBrandNameDisplay_s",
  "ctId_s",
  "ProductProductNo_s",
  "ProductServices_s",
  "InstallationAvailable_s",
  `priceList.ANY.price_d`,
  "RegionSupplyChain_ss",
  "BundleList_ss",
  "bundleNameSlugDetails_ss",
]

const constUpdates = Object.assign(CONSTANTS, {
  REGEX_NUMBER: /^[0-9]*$/,
  REGEX_PHONE_NUMBER: /^[6-9]{1}[0-9]{9}$/,
  REGEX_USER_TEXT: /^[a-zA-Z-,'\s]+$/,
  INVALID_OTP: "Invalid code. Try again.",
  SESSION_EXPIRED: "Your session has expired. Please try to sign in again.",
  TOO_MANY_ATTEMPTS: "Too many attempts. Try again later.",
  CURRENCY_SIGN: "₹",
  KEMP_PERSONA: "IN_Kohler_Registered_Consumer:KEMP",
  REGEX_EMAIL: /^[A-Za-z0-9]+([._+-][A-Za-z0-9]+)*@[A-Za-z0-9]+([.-][A-Za-z0-9]+)*\.[A-Za-z]{2,}$/i,
  REGEX_EMAIL_OPTIONAL: /^(?:[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.(com|co\.in))?$/i,
  REGEX_PINCODE: /^[1-9][0-9]{5}$/,
  REGEX_NO_OF_BATHROOM_OPTIONAL:  /^(0?[1-9]|[1-9][0-9])?$/,
  REGEX_NO_OF_BATHROOM_MANDATORY:  /^(0?[1-9]|[1-9][0-9])$/,
})

const compTypeUpdates = Object.assign(COMPONENT_TYPES, {
  FIND_A_STORE: "find-a-store-detail",
  CUSTOMER_SUPPORT: "kohler-india/components/customersupport",
  DEALER_ENQUIRY: "Dealership Enquiry",
  PRODUCT_ENQUIRY: "Product Enquiry",
  RETURNS: "Returns",
  RETURN_CONFIRMATION: "Return Confirmation",
  RETURN_REQUEST: "Return Request",
  FIND_BY_PINCODE: "/maps/get-city-state-with-pincode?pincode=",
  PRESS_LANDING: "press-release-landing",
  LIST: "/list/v1/list",
  BLOG_PAGE: "blogtab",
  LEAD_GENERATION: "leadgenerationform",
  QUIZ: "identifymymirrorflow",
  VISUAL_NAV_FILTER: "visual-nav-filter",
})

export const ESTIMATED_TOTAL_FOR_PAN_CONSENT = 200000
export const ESTIMATED_TOTAL_FOR_NO_COST_EMI = 10000
export const FILTER_WIDGET_PLP = "/p/online/shop"
export const cancellationReason =
  "Cancel reason is not specified by the customer."
export const pdpResourceFacetLabels = ["ProductIsExclusive_s"]

export const SEARCH_PDP_FL = [
  "CustomerFacingSKU_s",
  "ProductServices_ss",
  "ProductPriceSpiderIncluded_s",
  "SKUIsProjectPack_s",
  "Color.SKU.Details_ss",
  "ProductYoutubeID_s",
  "ProductOverallLengthInches_s",
  "ProductOverallWidthInches_s",
  "ProductOverallHeightInches_s",
  "ProductWebFeatures_ss",
  "ProductFreightPolicyType_s",
  "priceList.*.finalPrice_d",
  "priceList.*.saleOffer_s",
  "ProductWebTechnology_ss",
  "ProductNarrativeDescription_s",
  "ProductWebMaterial_ss",
  "ProductWebInstallation_ss",
  "ProductWebHydrotherapy_ss",
  "ProductWebRebates_ss",
  "SKUDiscontinuedDate_dt",
  "ProductResource.YouTubeInstallVideo.resourceName_ss",
  "ProductResource.YouTubeInstallVideo.resourceTitle_ss",
  "ctProductType_s",
  "isCollapsedPDP_b",
  "productInRiverId_s",
  "sku_s",
  "SKUCountryofOrigin_s",
  "ProductOverallLengthCm_d",
  "ProductOverallWidthCm_d",
  "ProductOverallHeightCm_d",
  "ProductPackageContents_s",
  "InstallationCost_s",
  "RequiredAccessoryGroupName_ss",
  "RequiredAccessoryGroupProduct_ss",
  "Recommended_Accessories_ss",
  "RegionSoldOnline_b",
  "productDiscontinued_b",
  pdpResourceFacetLabels.join(","),
  resourceFacetLabels().join(","),
  "title_s",
  "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
  "ProductResource.SpecPDFFileName.resourceTitle_ss",
  "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
  "ProductResource.EnvironProdDecl.resourceTitle_ss",
  "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
  "ProductResource.HomeownersGuide.resourceTitle_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
  "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
  "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
  "ProductResource.DXFPlanView.resourceFullWebURL_ss",
  "ProductResource.DWGPlanView.resourceFullWebURL_ss",
  "ProductResource.DXFFrontView.resourceFullWebURL_ss",
  "ProductResource.DWGFrontView.resourceFullWebURL_ss",
  "ProductResource.DXFSideView.resourceFullWebURL_ss",
  "ProductResource.DWGSideView.resourceFullWebURL_ss",
  "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
  "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
  "ProductResource.3DRevit.resourceFullWebURL_ss",
  "ProductResource.3D3DS.resourceFullWebURL_ss",
  "ProductResource.3DSketchup.resourceFullWebURL_ss",
  "ProductResource.CutOutDXF.resourceFullWebURL_ss",
  "ProductResource.3DOBJ.resourceFullWebURL_ss",
  "productVideos.labelWithUrl_ss",
  "ProductWebFeatures_*_Title_s",
  "ProductWebFeatures_*_Description_ss",
  "relatedProduct_s",
  "relatedProduct.Details_ss",
  "productRegionAllVariantDiscontinued_b",
  "relatedProductLink_s",
  "relatedProductCategory_s",
  "relatedProductSlug_s",
]

export const staticClasses = {
  CONTAINER: "container responsivegrid",
  ONETRUST_ANALYTICS: "",
}
export const continueShippingUrl = "/p/promotions/sale"
export const paymentSubscriptionKey =
  process.env.NEXT_PUBLIC_PAYMENT_SUBSCRIPTION_KEY
export const PDP_SLIDER_SIZES = {
  largeIpadSize: 1024,
  mobileSize: 767,
  desktopSliderImages: 15,
  smallesIpadSliderImages: 12,
  imageReelTitle: "image reel",
}
export const OMNI_INSPIRATION_CATELOG_URL = "https://www.kohler.co.in/content/dam/kohler-com-INDIA/Authored%20Content/PDF/Kohler-Mirrors-Collection.pdf"
export const slotBookedMessage="The slot for this date is already booked. Please select another slot."
export const bookingExistMessage="An active appointment already exists on the Lead"
export * from "../src/constants"
export { constUpdates as CONSTANTS, compTypeUpdates as COMPONENT_TYPES }
export default CONSTANTS
